module.exports = __webpack_public_path__ + "img/S9012-ST.041aa646.jpg";